<template>
  <div class="panel-container">
    <!-- ALL PANELS -->
    <div
      class="panel-wrapper"
      :class="{
        'powerpoint-addin': isEnableAddinPowerpoint,
      }"
    >
      <AutoPanel v-if="canUseAIImprovingSlideContent" ref="AutoPanel" />
      <AIPanel v-else ref="AIPanel" />
      <!-- Define more Panel component here. For example: Content, Design, Audio, etc. -->
    </div>

    <!-- RIGHT NAV -->
    <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
    <div
      class="aha-right-nav"
      @mouseup.stop
      :class="{
        'powerpoint-addin-sticky': isEnableAddinPowerpoint
      }"
      name="ai-panel-tooltip-trigger"
    >
      <NavItem
        v-if="canUseAIImprovingSlideContent"
        :navItem="autoNavItem"
        @onNavItemClicked="togglePanel('AutoPanel')"
        :activeType="getPurpleActiveType(0, 'AutoPanel')"
      />
      <NavItem
        v-else
        :navItem="aiNavItem"
        @onNavItemClicked="togglePanel('AIPanel')"
        :activeType="getPurpleActiveType(1, 'AIPanel')"
      />
      <div class="right-nav__divider-wrapper">
        <div class="right-nav__divider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'

// components
import NavItem from '@/components-v2/presentation-editor/side-right/right-nav/NavItem.vue'
import AIPanel from '@/components-v2/presentation-editor/right-panel-container/AIPanel.vue'
import AutoPanel from '@/components-v2/presentation-editor/right-panel-container/AutoPanel.vue'

export default {
  components: {
    NavItem,
    AIPanel,
    AutoPanel,
  },

  data() {
    return {
      PANELS: ['AutoPanel', 'AIPanel'],
      activeNavItemIndex: 2,
    }
  },

  computed: {
    ...mapState({
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      canEditPresentation: (state) => state.canEditPresentation,
    }),

    ...mapGetters('featureToggles', ['canUseAIImprovingSlideContent']),

    aiNavItem() {
      return {
        name: 'AI',
        icon: {
          name: 'sparkles',
          width: 24,
          height: 24,
          viewBox: '0 0 20 20',
        },
      }
    },

    autoNavItem() {
      return {
        name: 'Auto',
        icon: {
          name: 'sparkles',
          width: 24,
          height: 24,
          viewBox: '0 0 20 20',
        },
      }
    },
  },

  methods: {
    getPurpleActiveType(currentIndex, panel) {
      const isActive = this.activeNavItemIndex === currentIndex
      const isPanelVisible = this.$refs[panel]?.panelVisible()

      return isActive && isPanelVisible ? 'purple' : ''
    },

    togglePanel(panel) {
      try {
        const panelIndex = this.PANELS.indexOf(panel)
        if (panelIndex < 0) return

        this.activeNavItemIndex = panelIndex

        const visibility = this.$refs[panel].panelVisible()
        // Hide all panels except the one being toggled
        this.PANELS.forEach((panelName) => {
          if (!panelName || !this.$refs[panelName]) return
          if (panelName !== panel) {
            this.$refs[panelName].hide()
          }
        })

        // Toggle the target panel based on its visibility
        this.$refs[panel].toggle(visibility)
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    show(panel, tabIndex = 0) {
      // Show the specified panel with the given tab index
      this.$refs[panel].show(tabIndex)
    },

    hide(panel) {
      this.$refs[panel].hide()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';
.panel-container {
  @apply flex;
}

.aha-right-nav {
  @apply bg-base-0 h-full pt-4 overflow-y-auto text-secondary-100 border border-base-30;
  box-shadow: 0px 10px 38px 0px #525F7F14;
  width: 98px;
  min-width: 98px;
  .right-nav__divider-wrapper {
    @apply w-full my-3;
    .right-nav__divider {
      @apply bg-secondary-20 h-0.25 my-0 mx-auto;
      width: 40px;
    }
  }
  &.powerpoint-addin-sticky {
    position: fixed;
    right: 0;
    z-index: 2;
    overflow-x: hidden;
  }
}

.panel-wrapper.powerpoint-addin {
  position: fixed;
  right: 98px;
  top: 60px;
  z-index: 1;
  height: calc(100% - 60px);
  overflow-y: auto;
}

.right-nav-content__quiz-team-set-up {
  @apply bg-base-0 w-full h-full;
  @apply absolute top-0 right-0 overflow-y-hidden z-20;
  @apply border-l border-base-30;
  animation-duration: 0.3s;
}
.editor-header-tab-container {
}
.animation-panel__wrapper{
  @apply absolute top-0 z-10;
  @apply bg-base-0 w-full;
  @apply right-0 overflow-y-auto z-20;
  @apply h-full fixed;
  border-left: 1px solid #ebebeb;
  animation-duration: 0.3s;
  @media (min-width: 768px) { // md screens
    height: 100%;
    width: 384px;
  }
}
.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
  z-index: 9;
}
</style>
